import React from 'react';
import { Route, Switch } from 'react-router-dom';
import FaqAnswersList from './faqAnswersList';
import EditFaqAnswer from './editFaqAnswer';

export default class FaqAnswers extends React.Component {
  render() {
    return (
      <Switch>
        <Route exact path="/dashboard/admin/faqAnswersList" component={FaqAnswersList} />
        <Route exact path="/dashboard/admin/faqAnswersList/updateFaqAnswer/:faqAnswerId?" component={EditFaqAnswer} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/faqAnswers/faqAnswers.js